<template>
    <div class="mainRoot">
        <div v-for="(item, index) in lang" :key="index" style="height: 100%; width: 100%; position: relative">
            <div v-show="currentPage == 'main'" @touchmove.prevent style="text-align: center">
                <!-- 工具栏 -->
                <div class="toolWrap" @touchmove.prevent>
                    <!-- <div
                    v-for="(item, index) in toolList"
                    :key="index.value"
                    :class="item.className"
                    :style="{ width: scale * 80 + 'px', height: scale * 80 + 'px' }"
                    @click="handleTool(item)"
                ></div> -->
                    <div class="toolLeftR">
                        <div class="fiveM">
                            <div
                                class="crystal"
                                @click="handleTool(22018, item[17])"
                                :style="{ width: scale * 80 + 'px', height: scale * 80 + 'px' }"
                            ></div>
                            <div class="toolText">{{ item[4] }}</div>
                        </div>
                        <div class="fiveM">
                            <div
                                class="occupied"
                                @click="handleTool(21202, item[18])"
                                :style="{ width: scale * 80 + 'px', height: scale * 80 + 'px' }"
                            ></div>
                            <div class="toolText">{{ item[5] }}</div>
                        </div>
                        <div class="toolFola">{{ item[3] }}</div>
                    </div>
                    <div class="toolLeftR">
                        <div class="fiveM">
                            <div
                                class="pooled"
                                @click="handleTool(21007, item[19])"
                                :style="{ width: scale * 80 + 'px', height: scale * 80 + 'px' }"
                            ></div>
                            <div class="toolText">{{ item[6] }}</div>
                        </div>
                        <div class="fiveM">
                            <div
                                class="qiangClass"
                                @click="handleTool(21002, item[20])"
                                :style="{ width: scale * 80 + 'px', height: scale * 80 + 'px' }"
                            ></div>
                            <div class="toolText">{{ item[7] }}</div>
                        </div>
                        <div class="fiveM">
                            <div
                                class="clear"
                                @click="handleTool(0, item[8])"
                                :style="{ width: scale * 80 + 'px', height: scale * 80 + 'px' }"
                            ></div>
                            <div class="toolText">{{ item[16] }}</div>
                        </div>
                    </div>
                </div>
                <div class="bigWrap">
                    <!-- 大地图 -->
                    <div class="big" ref="big" :style="{ width: scale * 840 + 'px', height: scale * 1240 + 'px' }">
                        <div
                            ref="main"
                            class="main"
                            :style="{
                                left: -4 * left + 'px',
                                top: -4 * top + 'px',
                                width: scale * 840 * 2 + 'px',
                                height: scale * 1200 * 2 + 'px'
                            }"
                        >
                            <div
                                :key="i"
                                v-for="(item, i) in positions"
                                :style="{ width: scale * 80 + 'px', height: scale * 80 + 'px' }"
                                @click="handleClickStatus(i, item)"
                                class="gezi"
                                :class="{
                                    occupied: item.state == 21202,
                                    pooled: item.state == 21007,
                                    qiangClass: item.state == 21002,
                                    crystal: item.state == 22018
                                }"
                            >
                                <!-- {{ parseInt(item.x) }}
                    <br />
                    {{ parseInt(item.y) }} -->
                            </div>
                        </div>
                    </div>

                    <div class="smallWrap" :style="{ display: isShow ? 'block' : 'none' }">
                        <!-- 小地图 -->
                        <div
                            class="small"
                            :style="{ width: (scale * 840) / 2 + 'px', height: (scale * 1200) / 2 + 'px' }"
                            ref="parent"
                            @touchmove.prevent
                        >
                            <div
                                class="mask"
                                @touchstart="onTouchStart"
                                @touchmove="onTouchMove"
                                @touchend="onTouchEnd"
                                ref="floatWindow"
                                :style="{
                                    left: left + 'px',
                                    top: top + 'px',
                                    width: (scale * 840) / 4 + 'px',
                                    height: (scale * 1240) / 4 + 'px'
                                }"
                            ></div>
                            <div
                                :key="i"
                                v-for="(item, i) in positions"
                                :style="{ width: (scale * 40) / 2 + 'px', height: (scale * 40) / 2 + 'px' }"
                                class="gezi"
                                :class="{
                                    occupied: item.state == 21202,
                                    pooled: item.state == 21007,
                                    qiangClass: item.state == 21002,
                                    crystal: item.state == 22018
                                }"
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="btnWrap">
                    <div @click="handleGoForm" class="btnSubmit">
                        <!-- <img src="../assets/img/submit.png" alt="" /> -->
                        <div @click.stop="isShow = !isShow" class="showSubmit">{{ isShow ? item[31] : item[32] }}</div>
                        {{ item[9] }}
                        <div @click.stop="currentPage = 'rule'" class="btnRule">
                            <img src="../assets/img/rule.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 提示消息 -->
            <div class="tooltip" v-show="tooltipMsg.length > 0">
                <div class="tooltiptext">{{ tooltipMsg }}</div>
            </div>
            <!-- 规则！！！！！！ -->
            <div v-show="currentPage == 'rule'" class="ruleClass">
                <div class="ruleTitle">
                    {{ item[0] }}
                </div>
                <div class="ruleMian">
                    <div v-html="item[1]"></div>
                </div>
                <div class="ruleClose" @click="currentPage = 'main'">{{ item[2] }}</div>
            </div>
            <!-- Form ！！！！！！ -->
            <div v-show="currentPage == 'form'" class="formClass">
                <img class="giftTop" src="../assets/img/giftTop.png" alt="" />
                <!-- 主要内容 -->
                <div class="information">
                    <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                        <!-- id -->
                        <el-form-item prop="id">
                            <div class="label">{{ item[12] }}:</div>
                            <el-input
                                v-model="ruleForm.id"
                                :placeholder="item[13]"
                                oninput="if(value.length>100)value=value.slice(0,100)"
                                @blur="onInputFocus"
                            ></el-input>
                        </el-form-item>
                        <!-- 验证码 -->
                        <div>
                            <el-form-item prop="verification">
                                <div class="label">{{ item[14] }}:</div>
                                <div class="verify">
                                    <el-input @blur="onInputFocus" v-model="ruleForm.verification" :placeholder="item[15]" id="verify">
                                    </el-input>
                                    <div class="code" @click="refresh">
                                        <img :src="verificationCode" alt="" />
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <!-- 规则 -->
                        <el-form-item>
                            <div class="ruleText" v-html="item[10]"></div>
                        </el-form-item>
                        <!-- 点击按钮 -->
                        <el-form-item>
                            <div class="exchange" v-show="!isDisable">
                                <div @click="currentPage = 'main'" style="display: inline-block">{{ item[11] }}</div>
                                <div @click="submitForm" style="display: inline-block">{{ item[9] }}</div>
                            </div>
                            <div class="exchange" v-show="isDisable">
                                <div class="dis" style="display: inline-block">{{ item[11] }}</div>
                                <div class="dis" style="display: inline-block">{{ item[9] }}</div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { lang } from '@/tool/lang'
import { myHTTP } from '../utils/net'
import html2canvas from 'html2canvas'

window.$ = $
export default {
    props: ['language'],
    data() {
        let scale = $(window).width() / 1108
        //创建 格子 坐标
        let positions = Array.from({ length: 630 }, (_, index) => ({
            x: (index % 21) * 2 * scale * 40 + (2 * scale * 40) / 2,
            y: Math.floor(index / 21) * 2 * scale * 40 + (2 * scale * 40) / 2,
            state: 0
        }))
        return {
            isDisable: false,
            lang: [{}],
            captchaId: '', // 验证码
            verificationCode: '', // 验证码地址
            isClick: true,
            currentPage: 'rule',
            fileUrl: '', //上传图片后的地址
            ruleForm: {
                id: '',
                verification: ''
            },
            rules: {
                id: [{ required: true, trigger: ['blur', 'change'] }],
                verification: [{ required: true, trigger: ['blur', 'change'] }]
            },
            scale,
            positions,
            // 小地图拖拽参数
            isShow: true,
            startX: 0,
            startY: 0,
            offsetX: 0,
            offsetY: 0,
            left: 0,
            top: 0,
            isScrolling: false,
            currentStatus: null,
            tooltipMsg: '',
            arrList: [],
            toolList: [
                {
                    value: 4,
                    className: 'crystal',
                    desc: '水晶'
                },
                {
                    value: 1,
                    className: 'occupied',
                    desc: '怪物刷新点'
                },
                {
                    value: 2,
                    className: 'pooled',
                    desc: '水池'
                },
                {
                    value: 3,
                    className: 'qiangClass',
                    desc: '墙体'
                },
                {
                    value: 0,
                    className: 'clear',
                    desc: '橡皮擦'
                }
            ]
        }
    },
    watch: {
        tooltipMsg(newValue, oldValue) {
            if (newValue) {
                let timeoutId = setTimeout(
                    function () {
                        this.tooltipMsg = ''
                        clearTimeout(timeoutId)
                    }.bind(this),
                    2000
                )
            }
        },
        currentPage(newValue, oldValue) {
            if (newValue) {
                this.tooltipMsg = ''
            }
        }
    },
    created() {
        for (let i in lang) {
            this.lang[0][i] = lang[i][this.language]
        }
        // console.log(lang, this.lang)
    },
    mounted() {},
    methods: {
        onInputFocus() {
            // 滚动到指定位置，例如页面顶部
            window.scrollTo(0, 0)
        },
        // 截取
        async captureScreenshot() {
            document.getElementsByClassName('mask')[0].style.display = 'none'
            document.getElementsByClassName('smallWrap')[0].style.display = 'block'
            this.isShow = true
            this.isDisable = true
            const container = this.$refs.parent[0]

            html2canvas(container).then(canvas => {
                // 生成的截图位于 canvas 对象中
                // 你可以将其导出为图像或进行其他操作
                const screenshotURL = canvas.toDataURL('image/jpeg')
                const blob = this.dataURLtoBlob(screenshotURL)
                const file = new File([blob], 'screenshot.png', { type: 'image/png' })
                const formData = new FormData()
                formData.append('file', file)

                myHTTP
                    .post('/api/v1/webgame/towerdefence2026/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(res => {
                        document.getElementsByClassName('mask')[0].style.display = 'block'
                        this.isDisable = false
                        if (res.data.code == 0) {
                            this.fileUrl = res.data.data.uploadFiles[0].fileUrl || ''
                            // console.log(this.fileUrl)
                        }
                    })
            })
        },
        async handleGoForm() {
            if (this.isDisable) {
                console.log('isDisable')
                return
            }
            this.arrList = this.positions.map(item => item.state)
            const filteredNumbers = this.arrList.filter(number => number == 22018) //水晶
            const twoNumbers = this.arrList.filter(number => number == 21202) //怪物
            if (filteredNumbers.length < 1) {
                this.tooltipMsg = this.lang[0][28]
                return
            }
            if (twoNumbers.length < 1) {
                this.tooltipMsg = this.lang[0][27]
                return
            }
            // const allZero = this.arrList.every(function(element) {
            //     return element === 0;
            // });
            // if (allZero) {
            //     this.tooltipMsg = this.lang[0][26];
            //     console.log('数组中全是0。');
            //     return
            // }
            this.captureScreenshot()
            this.getId()
            this.currentPage = 'form'
            this.ruleForm = {
                id: '',
                verification: ''
            }
        },
        dataURLtoBlob(dataURL) {
            let arr = dataURL.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                // arr[0]是data:image/png;base64
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n)

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }

            let imgFile = new Blob([u8arr], {
                type: mime
            })
            return imgFile
        },
        getId() {
            myHTTP.post('/api/v1/captcha/generate').then(res => {
                this.captchaId = res.data.data.captchaId
                myHTTP.get(`/api/v1/captcha/image/${res.data.data.captchaId}`).then(res => {
                    this.verificationCode = res.config.url
                    this.isClick = true
                })
            })
        },
        // 点击验证码
        refresh() {
            if (this.isClick) {
                this.isClick = false
                this.getId()
            } else {
                return
            }
        },
        handleTool(key, value) {
            this.currentStatus = key
            this.tooltipMsg = value
        },
        handleClickStatus(index, item) {
            this.handleJudge(index, item)
        },
        // 判断是否满足条件     22018); //水晶  21202); //怪物
        handleJudge(index, item) {
            let arr = this.positions.filter(pos => { return pos.state !== 0})
            if (this.currentStatus == 22018) {
                const filteredData = this.positions.filter(item => item.state === 22018)
                if (filteredData.length > 0) {
                    this.tooltipMsg = this.lang[0][21]
                    return
                }
            }

            const filteredIndexes = this.positions.filter(number => {
                return number.state == '22018'
            })
            const twoIndexes = this.positions.filter(number => {
                return number.state == '21202'
            })
            // console.log('符合条件的元素的下标：', filteredIndexes, twoIndexes)

            if (filteredIndexes.length > 0) {
                const blo = this.handleRadius(filteredIndexes[0], item, 2.5)
                if (blo) {
                    this.tooltipMsg = this.lang[0][30]
                    return
                }
            }
            if (twoIndexes.length > 0) {
                const hasMatch = twoIndexes.some(it => {
                    const blo = this.handleRadius(it, item, 1.5)
                    if (blo) {
                        return true // 终止循环
                    }
                })
                if (hasMatch) {
                    this.tooltipMsg = this.lang[0][29]
                    return
                }
            }
            if (this.currentStatus == 22018) {
                if (arr.length > 0) {
                    const hasMatch = arr.some(it => {
                        const blo = this.handleRadius(it, item, 2.5)
                        if (blo) {
                            return true // 终止循环
                        }
                    })
                    if (hasMatch) {
                        this.tooltipMsg = this.lang[0][30]
                        return
                    }
                }
            }
            if (this.currentStatus == 21202) {
                if (arr.length > 0) {
                    const hasMatch = arr.some(it => {
                        const blo = this.handleRadius(it, item, 1.5)
                        if (blo) {
                            return true // 终止循环
                        }
                    })
                    if (hasMatch) {
                        this.tooltipMsg = this.lang[0][29]
                        return
                    }
                }
            }
            this.positions[index].state = this.currentStatus
        },
        handleRadius(old, newv, rule) {
            const distance = Math.sqrt(Math.pow(newv.x - old.x, 2) + Math.pow(newv.y - old.y, 2))
            const r = this.scale * 80 * rule
            // console.log(distance, r)
            if (distance !== 0 && distance < r) {
                return true
            }
        },
        // 小地图拖动
        onTouchStart(e) {
            this.startX = e.touches[0].clientX
            this.startY = e.touches[0].clientY
            this.offsetX = this.left
            this.offsetY = this.top
            this.isScrolling = false
        },
        onTouchMove(e) {
            const x = e.touches[0].clientX - this.startX + this.offsetX
            const y = e.touches[0].clientY - this.startY + this.offsetY
            const maxX = this.$refs.parent[0].offsetWidth - this.$refs.floatWindow[0].offsetWidth
            const maxY = this.$refs.parent[0].offsetHeight - this.$refs.floatWindow[0].offsetHeight
            this.left = x < 0 ? 0 : x > maxX ? maxX : x
            this.top = y < 0 ? 0 : y > maxY ? maxY : y
            if (Math.abs(e.touches[0].clientX - this.startX) > 5 || Math.abs(e.touches[0].clientY - this.startY) > 5) {
                this.isScrolling = true
            }
        },
        onTouchEnd(e) {
            if (!this.isScrolling) {
                if (e.changedTouches[0].clientX < this.$refs.parent[0].offsetWidth / 2) {
                    this.left = 0
                } else {
                    this.left = this.$refs.parent[0].offsetWidth - this.$refs.floatWindow[0].offsetWidth
                }
            }
        },
        // 解析游戏 ID：支持 "区服-数字ID" 或纯数字
        parseUserId(raw) {
            let id = (raw || '').replace(/\s/g, '')
            if (id.indexOf('-') !== -1) {
                id = id.split('-').pop() || ''
            }
            return id
        },
        // 提交后刷新验证码（验证码一次性，成功/失败都要换新图）
        refreshCaptchaAfterSubmit() {
            this.ruleForm.verification = ''
            this.getId()
        },
        // 提交
        submitForm() {
            if (!this.ruleForm.id) {
                this.tooltipMsg = this.lang[0][33]
                return
            }
            if (!this.ruleForm.verification) {
                this.tooltipMsg = this.lang[0][34]
                return
            }
            // 截图未上传完成时 fileUrl 为空，后端会返回 20001 参数错误
            if (!this.fileUrl) {
                this.tooltipMsg = this.lang[0][26]
                return
            }
            let aclaim = this.parseUserId(this.ruleForm.id)
            // 非纯数字 ID：后端 CheckUser 也会当 20001，前端直接提示游戏 ID 错误
            if (!/^\d+$/.test(aclaim)) {
                this.tooltipMsg = this.lang[0][22]
                return
            }
            this.isDisable = true
            myHTTP
                .post('/api/v1/webgame/towerdefence2026/create', {
                    userId: aclaim,
                    arrList: this.arrList,
                    captchaValue: this.ruleForm.verification.replace(/\s/g, ''),
                    captchaId: this.captchaId.replace(/\s/g, ''),
                    upLoadFiles: [
                        {
                            fileUrl: this.fileUrl
                        }
                    ]
                })
                .then(res => {
                    this.isDisable = false
                    const code = res.data.code
                    // 错误码：20001 参数 20002 验证码 20003 游戏ID 30001 繁忙
                    if (code === 0) {
                        this.tooltipMsg = this.lang[0][25]
                    } else if (code === 20001) {
                        this.tooltipMsg = this.lang[0][26]
                    } else if (code === 20002) {
                        this.tooltipMsg = this.lang[0][23]
                    } else if (code === 20003) {
                        this.tooltipMsg = this.lang[0][22]
                    } else if (code === 30001) {
                        this.tooltipMsg = this.lang[0][24]
                    } else {
                        this.tooltipMsg = res.data.message || this.lang[0][24]
                    }
                    // 无论成功失败都刷新验证码，避免二次提交沿用已核销的验证码
                    this.refreshCaptchaAfterSubmit()
                })
                .catch(() => {
                    this.isDisable = false
                    this.tooltipMsg = this.lang[0][24]
                    this.refreshCaptchaAfterSubmit()
                })
        }
    }
}
</script>

<style scoped lang="less">
.mainRoot {
    position: relative;
    max-width: 1080px;
    background: url('../assets/img/mainBg.png') no-repeat;
    background-size: 100% 100%;
    height: 100%;
    padding-top: 2vw;

    //rule
    .ruleClass {
        height: 100%;
        width: 100%;
        background: url('../assets/img/ruleBg.png') no-repeat;
        background-size: 100% 100%;
        text-align: center;
        color: #fff;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-stroke: 1px #f00;
        .ruleTitle {
            background: url('../assets/img/ruleTitle.png') no-repeat;
            background-size: 100% 100%;
            min-width: 180/360 * 100vw;
            height: 50/360 * 100vw;
            margin: 0 auto !important ;
            display: inline-block;
            font-size: 4rem;
            line-height: 40/360 * 100vw;
            transform: translateY(48%);
            font-weight: 900;
            -webkit-text-stroke: 1px #4d1d9b;
        }
        .ruleMian {
            font-size: 2.6rem;
            line-height: 1.6;
            width: 80vw;
            padding: 6rem 4rem;
            text-align: left;
            margin: 0 auto !important;
            border: 0.6rem solid #00d0ea;
            border-radius: 1rem;
            max-height: 52vh;
            div {
                overflow-y: auto;
                height: 100%;
            }
        }
        .ruleClose {
            background: url('../assets/img/top.png') no-repeat;
            background-size: 100% 100%;
            min-width: 100/360 * 100vw;
            height: 40/360 * 100vw;
            margin: 3rem auto 0 !important ;
            display: inline-block;
            font-size: 3.2rem;
            line-height: 40/360 * 100vw;
            font-weight: 900;
            -webkit-text-stroke: 1px #0071a3;
        }
    }

    //form
    .formClass {
        position: relative;
        height: 100%;
        width: 100%;
        background: url('../assets/img/giftBg.png') no-repeat;
        background-size: 100% 100%;
        text-align: center;
        padding: 5rem 0 0;
        // 头图
        .giftTop {
            width: 87%;
        }
        // 输入信息
        .information {
            display: inline-block;
            font-size: 1.2rem;
            line-height: 1.5rem;
            color: #fff;
            width: 48.5rem;
            max-width: 600px;
            margin-top: 4rem !important;
            /deep/.el-form-item {
                margin-bottom: 2.1875rem !important;
                // 输入框头部信息
                .label {
                    font-size: 2.6rem;
                    line-height: 1.5;
                    text-align: left;
                    padding: 1.25rem 0 1rem 1.375rem;
                }
                // 验证码输入框
                .verify {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .el-input {
                        display: inline-block;
                        width: 30.875rem;
                        max-width: 430px;
                    }
                    #verify {
                        width: 30.875rem;
                        max-width: 430px;
                    }
                    .code {
                        flex: 1;
                        height: 6.75rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-left: 1.25rem;
                        background: white;
                        img {
                            cursor: pointer;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .ruleText {
                    line-height: 1.5;
                    text-align: left;
                    background: #45157a;
                    border-radius: 2rem;
                    padding: 2rem 2rem;
                    margin: 2rem 0 !important;
                    p {
                        height: 1rem;
                    }
                }
                .exchange {
                    div {
                        min-width: 200/720 * 100vw;
                        height: 76/720 * 100vw;
                        line-height: 76/720 * 100vw;
                        background: url('../assets/img/top.png') 100% 100% no-repeat;
                        background-size: 100% 100%;
                        margin: 0 24/720 * 100vw !important;
                        padding: 0 3vw;
                        font-size: 3.2rem;
                        font-weight: 900;
                        -webkit-text-stroke: 1px #0071a3;
                    }
                    .dis {
                        background: url('../assets/img/dis.png') 100% 100% no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
            // 输入框
            /deep/input {
                background: #381366;
                text-align: center;
                height: 6.75rem;
                width: 100%;
                max-width: 600px;
                max-height: 76px;
                border: 2px #00ceef solid;
                color: #8e75a3;
                font-size: 1.2rem;
                line-height: 1.5rem;
                box-shadow: 0 0.1875rem 0.1875rem 0 rgba(0, 0, 0, 0.42);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                border-radius: 2rem;
                font-size: 2.4rem;
            }
            // 错误信息
            /deep/.el-form-item__error {
                text-indent: 2.8125rem;
                color: #ff5565;
                font-size: 1.25rem;
            }
        }
    }

    //main
    // 工具栏
    .toolWrap {
        width: 92%;
        display: flex;
        // background: url('../assets/img/toolBg.png') 100% 100% no-repeat;
        background-size: 100% 100%;
        margin: 0 auto 2vw !important;
        border: 2px #bd52ff solid;
        border-radius: 2vw;
        color: #fff;
        font-size: 1.8rem;

        .toolLeftR {
            display: flex;
            justify-content: space-around;
            padding: 20/720 * 100vw 16/720 * 100vw;
            .fiveM {
                border-radius: 1vw;
                background: #9350c9;
                padding: 2vw 0;
                text-align: center;
                width: 104/720 * 100vw;
                div {
                    margin: 0 auto !important;
                }
                .toolText {
                    margin-top: 4px !important;
                    padding: 0.5vw;
                }
            }
        }
        .toolLeftR:first-child {
            width: 42%;
            background: #6a2eb5;
            border-right: 2px dashed #7443cf;
            position: relative;
            .toolFola {
                position: absolute;
                left: 0;
                top: 0;
                background: #bd52ff;
                padding: 0 2vw;
                border-radius: 1vw 1px;
            }
        }
        .toolLeftR:last-child {
            flex: 1;
        }
    }
    //

    .bigWrap {
        border: 1vw #00ceef solid;
        display: inline-block;
        position: relative;
        border-radius: 1vw;
        // 大地图
        .big {
            position: relative;
            overflow: hidden;
            .main {
                // background: url('../assets/img/gezig.png') no-repeat;
                position: absolute;
                background-size: 100% 100%;

                // .gezi:nth-child(2n) {
                //     background: pink;
                // }
            }
        }
        .smallWrap {
            border: 1vw #00ceef solid;
            display: inline-block;
            position: absolute;
            left: -6vw;
            border-radius: 1vw;
            bottom: -4vw;
            transition: all 1s ease;
            .small {
                // background: url('../assets/img/gezig.png') 100% 100% no-repeat;
                background-size: 100% 100%;
                display: block;
                .mask {
                    position: absolute;
                    background: rgba(198, 72, 150, 0.4);
                }
            }
        }
    }

    .gezi {
        display: inline-block;
        margin: 0 !important;
        padding: 0 !important;
        float: left;
        background: #795cb2;
        border: 1px dashed #492c82;
    }
    .small {
        .gezi {
            border: 0.5px dashed transparent;
            box-shadow: 0 0 0 0.5px #492c82;
            // border-image: linear-gradient(to bottom,transparent 50%, #492c82 50%) 0 0 100%/1px 0;
            // border-image: linear-gradient(to right,transparent 50%, #492c82 50%) 0 0 100%/1px 0;
        }
    }
    .occupied {
        background: url('../assets/img/occupied.png') 100% 100% no-repeat;
        background-size: 100% 100%;
    }
    .pooled {
        background: url('../assets/img/shuichi.png') 100% 100% no-repeat;
        background-size: 100% 100%;
    }
    .qiangClass {
        background: url('../assets/img/qiang.png') 100% 100% no-repeat;
        background-size: 100% 100%;
    }
    .crystal {
        background: url('../assets/img/crystal.png') 100% 100% no-repeat;
        background-size: 100% 100%;
    }
    .clear {
        background: url('../assets/img/clear.png') 100% 100% no-repeat;
        background-size: 100% 100%;
    }

    .scale {
        transform: scale(0) translate(100%, 100%);
        transition: all 1s ease;
    }
    // 工具栏
    .tooltip {
        width: 100%;
        position: fixed;
        left: 0;
        top: 24%;
        transform: translateY(-50%);
        text-align: center;
        z-index: 999;
        .tooltiptext {
            min-width: 60%;
            background: rgba(0, 0, 0, 0.3);
            display: inline-block;
            padding: 1.25rem;
            border-radius: 3.625rem;
            color: #ffffff;
            font-size: 2.6rem;
        }
    }

    // 按钮
    .btnWrap {
        display: flex;
        margin-top: 8vw !important;
        color: #fff;
        justify-content: center;
        width: 100%;
        img {
            width: 100%;
        }
        .showSubmit {
            min-width: 100/720 * 100vw;
            height: 50/720 * 100vw;
            line-height: 50/720 * 100vw;
            background: url('../assets/img/show.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            font-size: 2.2rem;
            font-weight: 100;
            -webkit-text-stroke: 1px #fff;
            position: absolute;
            right: 22rem;
            padding: 0 1rem;
        }
        .btnSubmit {
            min-width: 200/720 * 100vw;
            height: 76/720 * 100vw;
            line-height: 76/720 * 100vw;
            background: url('../assets/img/top.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            margin: 0 24/720 * 100vw !important;
            padding: 0 3vw;
            font-size: 3.2rem;
            font-weight: 900;
            -webkit-text-stroke: 1px #0071a3;
            position: relative;
        }
        .btnRule {
            display: inline-block;
            position: absolute;
            right: -7rem;
            width: 50/720 * 100vw;
            img {
                vertical-align: top;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/main.vue